<template>
  <div class="html">
    <banner
      :title="title"
      :content="content"
    />
    <div class="introduce">
      <p class="sub_title">
        产品介绍
      </p>
      <div class="content_A">
        <div
          v-for="fwjs in introduceList"
          :key="fwjs.id"
          class="content_list"
        >
          <div>{{ fwjs.content }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import banner from '@/views/securityServices/components/banner.vue'
export default {
  name: 'Risk',
  components: {
    banner
  },
  data() {
    return {
      title: '灵创互联网漏洞扫描分析系统',
      content:
                '',
      introduceList: [
        {
          id: 1,
          content:
                        '灵创科技提供全面的分析评估服务以彻底检查和分析组织的信息基础设施，发现安全问题，以确定对信息系统采用什么程度的安全保障力度。风险评估是对待评估对象的信息系统的影响、威胁和脆弱性进行全方位评估，归纳并总结该系统所面临的安全风险，为后续的安全规划和建设提供决策依据。'
        },
        {
          id: 2,
          content: '1、对资产进行识别， 并对资产的重要性进行赋值。'
        },
        {
          id: 3,
          content:
                        '2、对威胁进行识别， 描述威胁的属性， 并对威胁出现的频率赋值。'
        },
        {
          id: 4,
          content:
                        '3、对资产的脆弱性进行识别， 并对具体资产脆弱性的严重程度赋值。'
        },
        {
          id: 5,
          content: '4、根据威胁和脆弱性的识别结果判断安全事件发生的可能性。'
        },
        {
          id: 6,
          content:
                        '5、根据脆弱性的严重程度及安全事件所作用资产的重要性计算安全事件的损失。'
        },
        {
          id: 7,
          content:
                        '6、根据安全事件发生的可能性以及安全事件的损失，计算安全事件对组织的影响， 即风险值'
        }
      ],

      costList: [
        {
          id: 1,
          title: '全面评估',
          imgUrl: require('@/assets/securityServices/risk1.png'),
          content:
                        '对客户信息系统安全的各个方面的当前潜在威胁、弱点和影响进行全面的评估。'
        }

      ]
    }
  }
}
</script>

<style scoped>
@import '../../styles/utils.scss';
</style>
